export const ChartColors = {
    primary: '#10439F',    // Light purple for actual data
    secondary: '#874ccc',  // Dark purple for target data
    tertiary: '#C65bcf',   // Medium purple
    quaternary: '#E57373', // Orange
    quinary: '#80DEEA',    // Aqua for fifth metric
    senary: '#AED581',     // Sage green for sixth metric
    success: '#10B981',    // Green
    warning: '#FFB547',    // Orange
    danger: '#EF4444',     // Red
    info: '#3B82F6',       // Blue
    light: '#F3F4F6',      // Light gray
    dark: '#1F2937'        // Dark gray
};

export const ChartDefaults = {
    height: 400,
    markerSize: 6,
    strokeWidth: 3,
    fillOpacity: 0.3,
    cornerRadius: 25,
    legendSpacing: 40,
    maxLabelLength: 25
};

export const ChartThemes = {
    light: {
        background: '#ffffff',
        text: '#374151',
        grid: '#e5e7eb',
        border: '#d1d5db'
    },
    dark: {
        background: '#1f2937',
        text: '#f9fafb',
        grid: '#374151',
        border: '#4b5563'
    }
};

export const ChartAnimations = {
    duration: 1000,
    easing: 'easeInOutQuart'
};

 